/*-----------------------------------------------------------------
- Register Components
-----------------------------------------------------------------*/
// eslint-disable-next-line no-unused-vars
import Vue from 'vue';

import YRogueWrapper from './RogueWrapper/index.vue';
import YInfoBox from './InfoBox/index.vue';
import YProductCard from './ProductCard/index.vue';
import YCard from './Card/index.vue';
import YBlogCard from './BlogCard/index.vue';
// %import%

Vue.component('YRogueWrapper', YRogueWrapper);
Vue.component('YInfoBox', YInfoBox);
Vue.component('YProductCard', YProductCard);
Vue.component('YCard', YCard);
Vue.component('YBlogCard', YBlogCard);
// %register%
